import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'drive/';

class DriveService {

    getBaliseDrives(baliseId, offset = 0, limit = 30, startDate = null, endDate = null) {
        const params = new URLSearchParams();
        params.set('offset', String(offset));
        params.set('limit', String(limit));
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        const url = `${API_URL}getbalisedrives/${baliseId}?${params.toString()}`;
        return axios.get(url, { headers: authHeader() });
    }

    getDriveInfo(driveId) {
        return axios.get(API_URL + 'getdriveinfo/' + driveId, { headers: authHeader() });
    }

}

export default new DriveService();